import { User } from '@/api/dtos/User.schema.d'
import { UserSummary } from '@/api/dtos/BookingDetails.schema.d'
import { LoginCredentials } from '@/api/dtos/LoginCredentials.schema'
import * as userApi from '@/api/users'
import * as authApi from '@/api/auth'
import store from '@/store'
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
  getModule
} from 'vuex-module-decorators'
import router from '@/router'

export interface IUserStoreState {
  localUser: User | null
  users: UserSummary[]
}

@Module({ dynamic: true, store, name: 'users' })
class Users extends VuexModule implements IUserStoreState {
  public localUser: User | null = null
  public users: UserSummary[] = []

  @MutationAction({ mutate: ['users'], rawError: true })
  public async fetchUserSummaries (): Promise<{
    users: UserSummary[]
  }> {
    return {
      users: await userApi.getUsers()
    }
  }

  @MutationAction({ mutate: ['localUser'], rawError: true })
  public async login (
    loginCredentials: LoginCredentials
  ): Promise<{ localUser: User }> {
    await authApi.login(loginCredentials.email, loginCredentials.password)
    return {
      localUser: await userApi.getLocalUser() // TODO uncomment, testing only
      // localUser: {
      //   address: null,
      //   email: 'test1@user.com',
      //   firstName: 'Test',
      //   lastName: 'User',
      //   managerOf: [],
      //   ownerOf: [],
      //   phone: null,
      //   landlinePhone: null,
      //   isAdmin: true,
      //   isBanned: false,
      //   uuid: 'i890aud89ahdf9agq78gve9fg'
      // }
    }
  }

  @MutationAction({ mutate: ['localUser'] })
  public async tryResumeSession (): Promise<{ localUser: User | null }> {
    try {
      const localUser = await userApi.getLocalUser()
      return {
        localUser: localUser
      }
    } catch {
      try {
        await UsersModule.logout()
      } catch {}
    }
    return {
      localUser: null
    }
  }

  @MutationAction({ mutate: ['localUser'] })
  public async logout (withRouteSwitch = true): Promise<{ localUser: User | null }> {
    await authApi.logout()
    if (withRouteSwitch) await router.push('/login')
    return {
      localUser: null
    }
  }

  @MutationAction({ mutate: ['localUser'], rawError: true })
  public async refreshLocalUser (): Promise<{ localUser: User }> {
    return {
      localUser: await userApi.getLocalUser()
    }
  }
}

export const UsersModule = getModule(Users)
